module.exports = __webpack_public_path__ + "static/img/foot_logo.7a21714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foot_logo.png
// module id = z4Zg
// module chunks = 17